import { configureStore } from "@reduxjs/toolkit";
import { createLogger } from "redux-logger";
import inlineCardReducer from "../../engine/contents/underlines/inlineCardSlice";
import editorsReducer from "../../engine/editorsSlice";
import writingAlertReducer from "../../engine/contents/underlines/writingAlertsSlice";

const logger = createLogger({
  collapsed: true,
  diff: true,

  // ignore the reflow action because it's every second
  predicate: (_getState, action) => action.type !== "Editors/reflow",
});

export const theStore = configureStore({
  reducer: {
    writingAlerts: writingAlertReducer,
    editors: editorsReducer,
    inlineCard: inlineCardReducer,
  },
  middleware: [logger],
});
export default theStore;

export type RootState = ReturnType<typeof theStore.getState>;
export type AppDispatch = typeof theStore.dispatch;
